

import createValidatePropsMethod from './../lib/createValidatePropsMethod'

/**
 * Checks that the user is a valid object and doesn't have invalid props.
 * Will throw if it does
 * @param {object} user
 */
const validateUser = createValidatePropsMethod({
  'id': `Missing prop on user 'id'.`,
  'avatarUrl': `Missing prop on user 'avatarUrl'.`,
  'name': `Missing prop on user 'name'.`,
})


/**
 * Set the current user's details
 * @param {object} user Has properties avatarUrl and name
 */
export function setUser(user){
  validateUser(user)
  return {
    type: 'SET_USER',
    user,
  }
}

/**
 * Loads the names of all repositories, the users organisations and the users
 * name.
 */
export function loadBasicInfo(){
  return {
    type: 'LOAD_BASIC_INFO'
  }
}



// WEBPACK FOOTER //
// ./src/store/user/actions.js